<template>
  <div>
    <p>
      The phased orbit finder generates phased orbits triplets
      <katex-element expression="(N,\:P,\:Q)" /> in a given
      <katex-element expression="Q" /> range and altitude range. When clicking
      on a point from the displayed graph,
      <katex-element expression="(N,\:P,\:Q)" /> values are filled
      automatically.
    </p>
    <v-img
      contain
      :src="require('../../../assets/images/tooltip-phased-orbit-finder.png')"
      aspect-ratio="2"
    />

    <h4>Reminder</h4>
    <p>
      Phased orbits can be defined using three parameters
      <katex-element expression="N" />, <katex-element expression="P" /> and
      <katex-element expression="Q" /> such that
      <br />
      <katex-element
        expression="T_c = (N \cdot Q + P) T_{mn} = Q \cdot T_{d}"
      />,
      <br />
      where <katex-element expression="T_c" /> is the duration of the repeat
      cycle, <katex-element expression="T_{mn}" />s is the mean nodal period and
      <katex-element expression="T_{d}" /> is the orbital day.
      <br />
      <br />
      The orbital day is the revolution period of the planet with respect to the
      ascending node of the orbit.
      <br />
    </p>

    <ul>
      <li>
        <katex-element expression="Q = T_c / T_d" /> is the number of planet
        revolutions per repeat cycle.
      </li>
      <li>
        <katex-element expression="N + P/Q = T_d / T_{mn}" /> is the number of
        orbits per orbital day.
      </li>
      <li>
        <katex-element expression="N \cdot Q + P = T_c/T_{mn}" /> is the whole
        number of orbits per repeat cycle.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationGeometryPhasedOrbitFinder'
}
</script>
